// Handles the Send to Triver flow: reserves the invoice, downloads the PDF, and opens Triver dashboard
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { downloadUrl: String, triverUrl: String, reserveUrl: String }
  static targets = ["initial", "done"]

  async continue() {
    const reserved = await this.#reserve()
    if (!reserved) return

    this.#downloadPdf()
    this.#openTriver()
    this.#showDone()
  }

  resend(event) {
    event.preventDefault()
    this.#downloadPdf()
    this.#openTriver()
  }

  async #reserve() {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    const response = await fetch(this.reserveUrlValue, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': csrfToken,
        'Accept': 'text/vnd.turbo-stream.html'
      }
    })
    return response.ok
  }

  #downloadPdf() {
    const link = document.createElement("a")
    link.href = this.downloadUrlValue
    link.download = ""
    link.style.display = "none"
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  #openTriver() {
    window.open(this.triverUrlValue, "_blank")
  }

  #showDone() {
    if (this.hasInitialTarget) {
      this.initialTarget.classList.add("hidden")
    }
    if (this.hasDoneTarget) {
      this.doneTarget.classList.remove("hidden")
    }
  }
}
